import { Component, OnInit } from '@angular/core';
import { Route, RouteSearchParams, RouteService } from '../../services/route';
import { PageResponse } from '../../auth/base-capacitor-http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MemberManagementService, MemberSearchParams, UserDisplay, UserStats } from '../../auth/user-management.service';
import { NgSelectComponent } from '@ng-select/ng-select'; // Import standalone component directly


@Component({
  selector: 'routes-view-screen',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectComponent],
  templateUrl: './routes-view-screen.html',
  styleUrl: './routes-view-screen.css',
})
export class RoutesViewScreen implements OnInit{

  page: PageResponse<Route> = new PageResponse();
  params: RouteSearchParams = new RouteSearchParams();
  pageNumbers: number[] = [];
  pageSizeOptions = [5, 10, 25];

  memberSearchParams: MemberSearchParams = new MemberSearchParams();
  memberPage: PageResponse<UserDisplay>
  drivers: UserDisplay[] = [];

  constructor(private routeService: RouteService, private memberService: MemberManagementService ){

  }
  onScrollEnd(){
    if(this.memberPage.currentPage < this.memberPage.totalPages){
      this.loadDrivers();
    }
  }
  onSearch(search: any){}

  async loadDrivers(){
    this.memberPage = await this.memberService.getAllMemberData(this.memberSearchParams);
    const set = new Set(this.drivers);
    this.memberPage.data.forEach(d =>{
      set.add(d);
    });
    this.drivers = Array.from(set);
  }

  async loadPage(): Promise<void> {
    this.page = await this.routeService.findAll(this.params);
  }
  
  // Generate page buttons with ellipsis logic
  generatePageNumbers(): void {
    const maxVisible = 5;
    const half = Math.floor(maxVisible / 2);
    
    let start = Math.max(1, this.page.currentPage - half);
    let end = Math.min(this.page.totalPages, start + maxVisible - 1);
    
    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }
    
    this.pageNumbers = [];
    
    // First page + ellipsis
    if (start > 1) {
      this.pageNumbers.push(1);
      if (start > 2) this.pageNumbers.push(-1); // -1 = ellipsis
    }
    
    // Page numbers
    for (let i = start; i <= end; i++) {
      this.pageNumbers.push(i);
    }
    
    // Last page + ellipsis
    if (end < this.page.totalPages) {
      if (end < this.page.totalPages - 1) this.pageNumbers.push(-1);
      this.pageNumbers.push(this.page.totalPages);
    }
  }
  
  // Navigation
  goToPage(page: number): void {
    if (page >= 1 && page <= this.page.totalPages) {
      this.params.page = page;
      this.loadPage();
    }
  }
  
  previousPage(): void {
    if (this.page.currentPage > 1) {
      this.params.page --;
      this.loadPage();
    }
  }
  
  nextPage(): void {
    if (this.page.currentPage < this.page.totalPages) {
      this.params.page ++;
      this.loadPage();
    }
  }
  
  // Display calculations for "Showing X to Y of Z"
  get startIndex(): number {
    if (this.page.totalItems === 0) return 0;
    return (this.page.currentPage - 1) * this.params.size + 1;
  }
  
  get endIndex(): number {
    return Math.min(this.page.currentPage * this.params.size, this.page.totalItems);
  }
  async ngOnInit(): Promise<void> {
    this.page = await this.routeService.findAll(this.params);
  }

}
